module.exports = __webpack_public_path__ + "assets/img/gene1.dd628848.png";